<template>
  <div>
    <titleHead :headTitle="obj.title" :headText="obj.content"></titleHead>
    <div class="demand_detail_content warp mb-60">
      <div class="demand_detail_left">
        <div class="demand_detail_head">
          <div class="demand_detail_tips">
            <span class="demand_detail_title">{{ detail.title }}</span>
            <span class="demand_detail_date">发布时间：{{ detail.createDate }}</span>
          </div>
          <user-operation v-if="detail.title"  @onCollection ="goCollection()"    @callCollection="callCancelcollection()"  :shareObj="detail" :notStatus="status"></user-operation>
        </div>
        <div class="demand_detail_desc" v-if="detail">
          <div class="demand_box">
            <div class="demand_box_left">
              <p>发布人：{{detail.username}}</p>
              <p>发布类别：{{ detail.usertypestr }}</p>
              <p>项目所在地：{{detail.userloctionstr}}</p>
            </div>
            <div class="demand_box_right">
              <p>需求状态: {{detail.statusStr}}</p>
              <p>需求分类：{{ cate }}</p>
              <div class="fsb">
                <p>需求开始时间：{{ detail.beginDate }}</p>
                <p class="mr-50">需求结束时间：{{ detail.endDate }}</p>
              </div>
            </div>
          </div>
          <!-- <ul>
            <li>发布人：{{ detail.username }}</li>
            <li>需求状态：{{ detail.statusStr }}</li>
            <li>发布类别：{{ detail.usertypestr }}发布</li>
            <li>需求分类：{{cate}}</li>
            <li>
              项目所在地：{{
                detail.userloctionstr
              }}
            </li>
            <li>需求开始时间：{{ detail.beginDate }}</li>
            <li>需求结束时间：{{ detail.endDate }}</li>
          </ul> -->
        </div>
        <div class="demand_detail_btn" @click="onView()">
          查看联系方式 <span class="suupy_text">{{ panter }}</span>
        </div>

        <contTitle class="mt-60" :contTitle="contTitle" :obj="obj"></contTitle>
        <div class="mt-20 info_detail_desc" v-html="detail.content"></div>
      </div>
      <div class="demand_detail_right">
        <a v-if="advList.length > 0" :href="'//' + advList[0].url" target="_blank">
          <span>广告</span>
          <img class="search_prod" :src="advList[0].image" alt="" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { getAdv,getDemandDetail,getDemandRecruitDetail } from "@/api/information";
import{addCollection,getusercontact,iscollection,addBrowse,cancelcollection} from "@/api/coment"
import { getToken } from "@/utils/auth"
import titleHead from "../../common/titleHead";
import userOperation from "../../common/userOperation";
import contTitle from "../../common/contTitle";
export default {
  components: { titleHead, userOperation, contTitle },
  data() {
    return {
      obj: {
        title: "危机需求处理",
        content:
          "公司主营产品及服务包括：金属氧化物避雷器带电检测仪、数字式钳形伏安相位表、大型地网接地电阻测量仪、多通道波形记录仪、PT感应耐压试验电源、高压高稳定电源...",
      },
      contTitle: "需求描述",
      id: "",
      detail: "",
      cate: "",
      advList: [],
      panter:'',
	  advType:11,
      status: false,
      type:1,   // 需求类型
    };
  },
  created() {
    console.log("获取参数值",this.$route.query.type)
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    this.getDemandDetail(this.id,this.type);
    this.getAdv();
    if (getToken() != undefined) {
      this.getIscollection();
      this.getAddBrowse();
    }
  },
  methods: {
    getDemandDetail(id,type) {
      if (!id) return;
      if(type == 1){
        getDemandDetail({
          id: id,
        }).then((res) => {
          if (res.code == 0) {
            this.detail = res.data;
            this.obj.title = res.data.title;
            this.cate = this.getCate(this.detail.type);
          }
        });
      }else{
        getDemandRecruitDetail(id).then((res) => {
          console.log("人力资源详情",res)
          if (res.code == 0) {
            this.detail = res.demand;
            this.obj.title = res.demand.title;
            this.cate = this.getCate(this.detail.type);
          }
        })
      }
    },
    getCate(id) {
      return this.$store.getters.itemIndutry(id);
    },
    //需求收藏
    goCollection() {
      let params = {
        goodsId: this.$route.query.id,
        goodsType: 8,
      };
      addCollection(params)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "收藏成功！",
              type: "success",
            });
          }
        })
        .catch((err) => {});
    },
     //产品取消收藏
     callCancelcollection(){
       let params = {
          goodsid:this.$route.query.id,
          goodstype:"8"
       }
       cancelcollection(params).then((res)=>{
         if(res.code == 0){
            this.$message({
              type:"success",
              message:"取消收藏"
            })
         }
       }).catch((err)=>{})
     },
    getAdv() {
      getAdv({
        curPage: 1,
        limit: 10,
        type: this.advType,
      }).then((res) => {
        if(res.code == 0){
          this.advList = res.page.list;
        }
      });
    },
    //查看联系方式
    onView() {
      let params = {
        userid: this.detail.userId,
		goodsid:this.id,
		goodstype:8
      };
	  getusercontact(params).then((res)=>{
		if(res.code == 0){
		  this.panter = res.data.mobile;
		}
	  }).catch((err)=>{})
    },
    //查看收藏状态
    getIscollection() {
      let params = {
        goodsid: this.$route.query.id,
        goodstype: 8,
      };
      iscollection(params)
        .then((res) => {
          if (res.code == 0) {
            this.status = res.data;
          }
        })
        .catch((err) => {});
    },
    //浏览数增加
    getAddBrowse() {
      let postData = {
        goodsId:this.id,
        goodsType: 8,
        id: this.$store.state.user.userInfo.data.userId,
      };
      addBrowse(postData)
        .then((res) => {
          if (res.code == 0) {}
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped lang="less">
.demand_detail_content {
  display: flex;
  justify-content: space-between;
  .demand_detail_left {
    width: 1080px;
    margin-right: 20px;
    .demand_detail_head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .demand_detail_tips {
        width: 60%;
        .demand_detail_title {
          font-size: 21px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          margin-right: 40px;
          max-width: 525px;
          height: 55px;
          overflow: hidden;
          display: block;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .demand_detail_date {
          height: 14px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
        }
      }
    }
    .demand_detail_desc {
      border: 1px solid #eeeeee;
      // padding: 20px 30px 0;
      // height: 140px;
      margin: 20px 0;
      ul {
        display: flex;
        flex-wrap: wrap;
        li {
          width: 190px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          margin-bottom: 20px;
        }
      }
    }
    .demand_detail_btn {
      width: 15%;
      height: 35px;
      line-height: 27px;
      text-align: center;
      background: #68be31;
      border-radius: 3px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      padding: 5px 0;
      cursor: pointer;
      margin-bottom: 20px;
      position: relative;
      .suupy_text {
        right: -115px;
        top: 5px;
        font-size: 14px;
        display: block;
        position: absolute;
        font-family: Microsoft YaHei;
        color: #000;
      }
    }
  }
  .demand_detail_right {
    width: 20%;
    position: relative;
    span {
      position: absolute;
      top: 5px;
      left: 5px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }
    img {
      width: 100%;
      height: 150px;
    }
  }
}
.mb-60 {
  margin-bottom: 60px;
}
.mt-20 {
  margin-top: 20px;
}
.mt-60 {
  margin-top: 60px;
}
.fsb{
  display: flex;
  justify-content: space-between;
}

.ml-30 {
  margin-left: 30px;
}
.mr-50{
  margin-right: 50px;
}
.college_meter {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}

.demand_box {
  display: flex;
  justify-content: space-between;
  margin: 10px 20px;
}
.demand_box_left{
  width: 35%;
}
.demand_box_left p{
  padding: 10px 0px;
  font-size: 14px;
  color: #333333;
}
.demand_box_right{
   flex: 1;
   margin-left: 45px;
}
.demand_box_right p{
  padding: 10px 0px;
  font-size: 14px;
  font-size: #333333;
}

</style>



// WEBPACK FOOTER //
// src/view/supply_demand/demand_detail.vue